import { render, staticRenderFns } from "./DetailsNew.vue?vue&type=template&id=701cde5f"
import script from "./DetailsNew.vue?vue&type=script&lang=js"
export * from "./DetailsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports